// extracted by mini-css-extract-plugin
export default {"flexContainer":"StackedBarChart_flexContainer__5IWul","flexItemLeft":"StackedBarChart_flexItemLeft__u87Qk","flexItemRight":"StackedBarChart_flexItemRight__SAPA-"};